import { version } from '../../package.json';
export default version;



// WEBPACK FOOTER //
// ./components/version/index.tsx